<template>
  <div class="form-group" :class="className">
    <label :for="textareaId" class="form-label">{{ labelName }}</label>
    <textarea
      :id="textareaId"
      :aria-describedby="textareaId"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="modelValue"
      class="form-control pj-input"
      :class="{ 'is-invalid': errorMessage }"
      @input="change($event.target.value)"
      ref="textarea"
    />
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div :id="textareaId" class="form-text"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, toRefs, watch, nextTick } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "InputFieldTextarea",
  emits: ["update:modelValue"],
  props: {
    labelName: String,
    placeholder: String,
    textareaId: String,
    className: String,
    modelValue: [String, Number],
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: { type: Boolean, default: true },
  },
  setup: (props, { emit }) => {
    const { modelValue } = toRefs(props);
    const { t } = useI18n();
    const errorMessage = ref("");
    const error = ref(false);
    const textarea = ref(null as HTMLInputElement | null);
    const textareaValue = ref<unknown>("" as string);

    const validate = (): boolean => {
      if (!textareaValue.value && props.required) {
        errorMessage.value = t("SHARED.FIELD_REQUIRED");
        error.value = true;
        return false;
      } else {
        error.value = false;
        errorMessage.value = "";
      }
      emit("update:modelValue", textareaValue.value);
      return true;
    };

    watch(textareaValue, (value: unknown) => {
      textareaValue.value = value;
      if (value !== "" && value !== undefined) {
        emit("update:modelValue", textareaValue.value);
      }
    });

    watch(
      () => props.modelValue,
      () => {
        textareaValue.value = props.modelValue;
      }
    );

    onMounted(() => (textareaValue.value = modelValue.value));

    const change = (value: string) => {
      textareaValue.value = value;
      nextTick(() => {
        validate();
        emit("update:modelValue", textareaValue.value);
      });
    };

    return {
      t,
      change,
      textarea,
      textareaValue,
      errorMessage,
      validate,
    };
  },
});
</script>
